import React, { useState, useEffect, useContext } from "react";
import { Card, Row, Col, Spin, Tabs, Layout, theme, Button, Rate } from "antd";
import { PlusOutlined, FireOutlined, FireFilled } from "@ant-design/icons";
import MenuItem from "./MenuItem";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";

const { Meta } = Card;

export default function MenuRegular() {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const { promotions, promotionProducts } = useContext(PublicContext);
    const [selectedStore, setSelectedStore] = useState(1);
    const [selectedPromo, setSelectedPromo] = useState();

    const [menuItem, setMenuItem] = useState({
        productName: "",
        price: 0,
        description: "",
        pictureURL: "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png",
    });

    const { Header, Content, Footer } = Layout;

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const [openDrawer, setOpenDrawer] = useState(false);

    function selectMenuItem(item, promo) {
        setSelectedPromo(promo);
        setMenuItem(item);
        setOpenDrawer(true);
    }

    useEffect(() => {
        getStore();
    }, []);

    function getStore() {
        setSelectedStore(sessionStorage.getItem("selectedStore"));
        populateProductCategories();
        populateProductsData(selectedStore.storeId);
    }

    function renderDrawer() {
        return (
            <MenuItem
                menuItemProp={menuItem}
                selectedPromo={selectedPromo}
                setOpenDrawer={setOpenDrawer}
            />
        );
    }

    function renderCategories() {
        console.log("render product catagory");
        return (
            <Layout className="layout">
                <Tabs
                    tabPosition="top"
                    className="menu_catagory"
                    items={categories.map((category, index) => {
                        //   const id = String(i + 1);
                        return {
                            label: category.categoryName,
                            key: category.categoryName + index,
                            children: renderProductsTable(index),
                            // children: id,
                        };
                    })}
                />
            </Layout>
        );
    }

    const SpicinessRating = ({ value }) => {
        const fullIcons = Math.floor(value);
        const partialIcon = value - fullIcons > 0 ? 1 : 0;

        const icons = Array.from({ length: fullIcons + partialIcon }).map(
            (_, index) => <FireFilled key={index} style={{ color: "red" }} />
        );

        return <>{icons}</>;
    };

    function renderPromotionTag(productCode) {
        if (promotionProducts.some((pp) => pp.buyProductCode === productCode)) {
            const pps = promotionProducts.find(
                (pp) => pp.buyProductCode === productCode
            );
            const ps = promotions.find((p) => p.id === pps.promotionId);
            return (
                <div
                    style={{
                        position: "absolute",
                        top: "8px",
                        left: "8px",
                        borderRadius: "6px",
                        backgroundColor: "#38803d",
                        color: "white",
                        padding: "4px",
                        zIndex: 2,
                    }}
                >
                    {ps.promotionName}
                </div>
            );
        }
    }

    function renderProductsTable(categoryId) {
        console.log("render product table");
        return (
            <Row
                key={"productRow" + categoryId}
                gutter={[
                    { xs: 8, sm: 8, md: 16, lg: 16 },
                    { xs: 8, sm: 8, md: 16, lg: 16 },
                ]}
            >
                {products.map((product) => {
                    // console.log(product.productCategoryId);
                    if (product.productCategoryId === categoryId + 1) {
                        // console.log("IN: " + product.productCategoryId);
                        const promoProduct = promotionProducts.find(pp => pp.buyProductCode === product.productCode);
                        var promo = null;
                        if (promoProduct) {
                            promo = promotions.find(
                                (p) => p.promotionType === "BuyXGetY" && p.id === promoProduct.promotionId
                            );
                        }
                        return (
                            <Col
                                key={"product" + product.id}
                                className="gutter-row"
                                xs={12}
                                sm={12}
                                md={8}
                                lg={6}
                                xl={6}
                            >
                                <Card
                                    key={"productcard" + product.id}
                                    hoverable
                                    height="100px"
                                    bordered
                                    cover={
                                        // <img
                                        //   alt={product.productName}
                                        //   src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                        //   onError={(e) =>
                                        //     (e.target.src =
                                        //       "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png")
                                        //   }
                                        // />
                                        <div style={{ position: "relative", overflow: "hidden" }}>
                                            {/* Promotion tag */}
                                            {/* {product.promotion && (
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              backgroundColor: "rgba(255, 165, 0, 0.8)", // Orange color
                              padding: "4px",
                              zIndex: 2,
                            }}
                          >
                            {product.promotion}
                          </div>
                        )} */}
                                            {renderPromotionTag(product.productCode)}
                                            {/* Product image */}
                                            <img
                                                alt={product.productName}
                                                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                                style={{ height: "auto", width: "100%" }}
                                                onError={(e) => {
                                                    e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                                    e.target.onerror = null;
                                                }}
                                            />
                                            {/* Floating button with plus sign */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "8px",
                                                    left: "8px",
                                                    padding: "4px",
                                                    zIndex: 2,
                                                }}
                                            >
                                                <SpicinessRating value={product.spiciness} />
                                            </div>
                                        </div>
                                    }
                                    onClick={() => {
                                        selectMenuItem(product, promo);
                                    }}
                                >
                                    <h6>{product.productName}</h6>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        {/* <p style={{ flex: "1" }}>{`${product.kCal} kCal`}</p> */}
                                        <p style={{ flex: "1" }}>x kCal</p>
                                        <p style={{ marginLeft: "8px" }}>
                                            <b>{`$${product.price}`}</b>
                                        </p>
                                    </div>
                                    {/* <p>
                      X kCal{" "}
                      <span>
                        <b>{"$" + product.price}</b>
                      </span>
                    </p> */}
                                    {/* <p>{"$" + product.price}</p> */}
                                    <p>Short descriptions</p>
                                    {/* {product.isSpicy && ( */}
                                    {/* // Display hot pepper icons for spicy food */}

                                    {/* <Rate
                      character={<FireOutlined style={{ color: "red" }} />}
                      allowHalf
                      disabled
                      defaultValue={2.5}
                      // value={product.spiciness}
                    /> */}
                                    {/* <Button
                      type="primary"
                      shape="circle"
                      icon={<PlusOutlined />}
                      style={{
                        backgroundColor: "#f17fb2",
                        position: "absolute",
                        height: "50px",
                        width: "50px",
                        bottom: "8px",
                        right: "8px",
                        zIndex: 1,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        selectMenuItem(product);
                      }}
                    /> */}
                                </Card>
                            </Col>
                        );
                    } else {
                        return <></>;
                    }
                })}
            </Row>
        );
    }

    async function populateProductCategories(storeId) {
        console.log("populate product categories");
        const response = await fetch("api/ProductCategories");

        const data = await response.json();
        setCategories(data);
        console.log(data);
        // setLoading(false);
    }

    async function populateProductsData(storeId) {
        if (localStorage.getItem("products")) {
            setProducts(JSON.parse(localStorage.getItem("products")));
            setLoading(false);
        } else {
            const response = await fetch("api/Products");
            const data = await response.json();
            setProducts(data);
            localStorage.setItem("products", JSON.stringify(data));
            console.log(data);
            setLoading(false);
        }
    }

    function renderLoading() {
        return <Spin />;
    }

    return (
        <div>
            {loading ? renderLoading() : renderCategories()}
            {openDrawer && renderDrawer()}
        </div>
    );
}
